import React, { useState } from 'react';

function ReservationSearchModal({ show, onClose }) {
  const [studentId, setStudentId] = useState('');
  const [studentName, setStudentName] = useState('');
  const [studentEmail, setStudentEmail] = useState('');
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  const studentIdRegex = /^[BMDIJ]\d{9}$/;
  const nameRegex = /^[\u4E00-\u9FA5A-Za-z\s]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!show) return null;

const handleSearch = async () => {
  if (!studentId || !studentName || !studentEmail) {
    setError('請填寫學號、姓名與 Email (Please fill in Student ID, Name, and Email)');
    return;
  }
  if (!studentIdRegex.test(studentId)) {
    setError('學號格式錯誤，請輸入有效的學號 (Invalid Student ID format, please enter a valid ID)');
    return;
  }
  if (!nameRegex.test(studentName)) {
    setError('姓名格式錯誤，僅能包含中文或英文 (Invalid Name format, only Chinese or English characters are allowed)');
    return;
  }
  if (!emailRegex.test(studentEmail)) {
    setError('Email 格式錯誤 (Invalid Email format)');
    return;
  }

try {
  const query = `studentId=${encodeURIComponent(studentId)}&studentName=${encodeURIComponent(studentName)}&studentEmail=${encodeURIComponent(studentEmail)}`;
  const res = await fetch(`/api/reservations?${query}`);
  const data = await res.json();
  if (res.ok) {
    if (data.length === 0) {
      setError('查無相應的預約紀錄 (No matching reservation records found)');
      setRecords([]);
    } else {
      setRecords(data);
      setError('');
    }
  } else {
    setError(data.error || '查詢失敗 (Search failed)');
  }
} catch (err) {
  console.error('ReservationSearchModal handleSearch error:', err);
  setError('與伺服器連線發生錯誤 (Error connecting to the server)');
}
  };
const handleCancel = async (rid) => {
  if (!window.confirm('確認取消預約？(Are you sure you want to cancel this reservation?)')) return;
  try {
    const res = await fetch(`/api/reservations/${rid}`, {
      method: 'DELETE',
    });
    const data = await res.json();
    if (res.ok) {
      // 在成功取消後從 records 中移除已取消的預約
      setRecords(records.filter(record => record.id !== rid));
    } else {
      alert(data.error || '取消預約失敗 (Failed to cancel the reservation)');
    }
  } catch (err) {
    alert('取消預約時發生錯誤 (An error occurred while cancelling the reservation)');
  }
  };

  return (
    <>
      <div className="modal fade show" style={{ display: 'block' }} role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">查詢預約紀錄</h5>
              <button type="button" className="btn-close" onClick={onClose} />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label>學號(Student ID)：</label>
                <input
                  className="form-control"
                  value={studentId}
                  onChange={(e) => setStudentId(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>姓名(Name)：</label>
                <input
                  className="form-control"
                  value={studentName}
                  onChange={(e) => setStudentName(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label>Email：</label>
                <input
                  className="form-control"
                  value={studentEmail}
                  onChange={(e) => setStudentEmail(e.target.value)}
                />
              </div>
              {error && <p className="text-danger">{error}</p>}

              {records.length > 0 && (
                <table className="table table-bordered mt-3">
                  <thead>
                    <tr>
                      <th>活動名稱(Event)</th>
                      <th>日期(Date)</th>
                      <th>時間(Time)</th>
                      <th>取消(Cancel)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map(r => (
                      <tr key={r.id}>
                        <td>{r.eventName}</td>
                        <td>{r.date}</td>
                        <td>{r.startTime} - {r.endTime}</td>
                        <td>
                          <button className="btn btn-danger btn-sm" onClick={() => handleCancel(r.id)}>
                            取消預約(Cancel Reservation)
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={handleSearch}>搜尋</button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>關閉</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" />
    </>
  );
}

export default ReservationSearchModal;